import { isEmpty } from 'lodash'

// Helpers for the Overview-tab voice picker: display-label mapping for the
// BE's catalog values and the client-side filter over the full catalog (the
// catalog is a few hundred voices and is fetched whole, so search/filters
// run locally instead of round-tripping).

export const VOICE_PAGE_SIZE = 10
export const VOICE_SAY_MAX_LENGTH = 500

export const GENDER_OPTIONS = [
  { value: 'masculine', label: 'Male' },
  { value: 'feminine', label: 'Female' },
  { value: 'gender_neutral', label: 'Neutral' },
]

export const genderLabel = (value) => {
  const option = GENDER_OPTIONS.find((entry) => entry.value === value)
  return option ? option.label : value
}

// BE languages are ISO 639-1 codes ("en"); render them as English display
// names. Constructed lazily inside the guarded path: Intl.DisplayNames throws
// on malformed codes (and may be missing entirely in older environments) —
// fall back to the raw code so the panel never breaks over a label.
let languageDisplayNames

export const languageLabel = (code) => {
  if (!code) {
    return ''
  }
  try {
    languageDisplayNames =
      languageDisplayNames || new Intl.DisplayNames(['en'], { type: 'language' })
    return languageDisplayNames.of(code)
  } catch (error) {
    return code
  }
}

// Build the Language filter options from the codes actually present in the
// loaded catalog, sorted by display label.
export const languageOptionsFromVoices = (voices) => {
  const codes = [...new Set(voices.map((voice) => voice.language).filter(Boolean))]
  return codes
    .map((code) => ({ value: code, label: languageLabel(code) }))
    .sort((left, right) => left.label.localeCompare(right.label))
}

// Free-text search matches name/description/id (mirrors the BE's `q`
// semantics); gender/language are multi-select — an empty selection means
// "no filter".
export const filterVoices = (voices, { search = '', genders = [], languages = [] }) => {
  const query = search.trim().toLowerCase()
  return voices.filter((voice) => {
    if (query) {
      const haystack = `${voice.name} ${voice.description || ''} ${voice.voiceId}`.toLowerCase()
      if (!haystack.includes(query)) {
        return false
      }
    }
    if (!isEmpty(genders) && !genders.includes(voice.gender)) {
      return false
    }
    if (!isEmpty(languages) && !languages.includes(voice.language)) {
      return false
    }
    return true
  })
}
